import { useFlags } from 'launchdarkly-react-client-sdk'
import { FeatureFlags } from 'types/types'

export const useFeatureFlags = () => (useFlags() ?? {}) as FeatureFlags
